export default __webpack_public_path__ + "static/media/ProfileBackground.afc1c4a9.svg";